export const APP_NAME = 'Frontline UI';
export const VENDOR_NAME = 'Blackbox Company (UK) Ltd.';
export const WEB_HOST: string = 'frontline.dcis.io';
export const API_HOST: string = 'frontline-api.dcis.io';
export const DRAWER_WIDTH = 240;
export const STORAGE_ACCOUNT = 'bbxstoragedcis';